import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useDispatch } from 'react-redux';
import { crearCita } from '../Redux/Actions/citasAction';

const PHONE_CODES = [
  { code: '+549', label: '🇦🇷 +549' },
  { code: '+52', label: '🇲🇽 +52' },
  { code: '+56', label: '🇨🇱 +56' },
  { code: '+1', label: '🇺🇸 +1' },
  { code: '+34', label: '🇪🇸 +34' },
];

const HOURS = ['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00'];

const CONTACT_LINKS = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    label: 'WhatsApp',
    value: '+54 9 2241 56-3807',
    href: 'https://wa.me/5492241563807',
    color: '#25d366',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    label: 'LinkedIn',
    value: 'Juan Martín Arrayago',
    href: 'https://www.linkedin.com/in/juan-martin-arrayago/',
    color: '#0077b5',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
      </svg>
    ),
    label: 'GitHub',
    value: '@ArrayagoM',
    href: 'https://github.com/ArrayagoM',
    color: '#f0f0f0',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
    label: 'Email',
    value: 'juanmartinarrayago@gmail.com',
    href: 'mailto:juanmartinarrayago@gmail.com',
    color: '#ff4500',
  },
];

const InputField = ({ label, icon, children, error }) => (
  <div style={{ marginBottom: '1.25rem' }}>
    <label style={{ display: 'block', color: 'rgba(242,242,242,0.65)', fontSize: '0.8rem', fontWeight: 500, marginBottom: '0.5rem', letterSpacing: '0.5px' }}>
      {label}
    </label>
    {children}
    {error && <p style={{ color: '#fc8181', fontSize: '0.75rem', marginTop: '0.3rem' }}>{error}</p>}
  </div>
);

const inputStyle = {
  width: '100%', padding: '0.75rem 1rem',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: '10px', color: '#f2f2f2',
  fontSize: '0.9rem', outline: 'none',
  transition: 'border-color 0.2s',
  boxSizing: 'border-box',
};

const Contact = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '', email: '', phoneNumber: '', phoneCode: '+549',
    message: '', agendarEnGoogle: false, fecha: '', hora: '',
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = 'El nombre es obligatorio';
    if (!formData.email.trim()) e.email = 'El email es obligatorio';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) e.email = 'Email inválido';
    if (!formData.phoneNumber.trim()) e.phoneNumber = 'El teléfono es obligatorio';
    if (!formData.message.trim() || formData.message.length < 10)
      e.message = 'El mensaje debe tener al menos 10 caracteres';
    if (formData.agendarEnGoogle) {
      if (!formData.fecha) e.fecha = 'Seleccioná una fecha';
      if (!formData.hora) e.hora = 'Seleccioná una hora';
    }
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }

    setLoading(true);
    try {
      const fullPhone = formData.phoneCode + formData.phoneNumber;
      await dispatch(crearCita({ ...formData, phoneNumber: fullPhone }));
      setSubmitted(true);
      setFormData({ name: '', email: '', phoneNumber: '', phoneCode: '+549', message: '', agendarEnGoogle: false, fecha: '', hora: '' });
    } catch {
      setErrors({ general: 'Ocurrió un error. Intentá de nuevo.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" style={{ background: '#0f0f0f', padding: '6rem 0' }}>
      <style>{`
        .contact-input:focus { border-color: rgba(255,69,0,0.5) !important; box-shadow: 0 0 0 3px rgba(255,69,0,0.08); }
        .contact-input::placeholder { color: rgba(242,242,242,0.2); }
        .contact-link-card:hover { background: rgba(255,255,255,0.05) !important; transform: translateY(-2px); }
        .send-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 0 30px rgba(255,69,0,0.5) !important; }
      `}</style>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 1.5rem' }}>

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: 'center', marginBottom: '4rem' }}
        >
          <p style={{ color: '#ff4500', fontSize: '0.8rem', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
            Trabajemos juntos
          </p>
          <h2 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', color: '#f2f2f2', fontWeight: 800, marginBottom: '1rem' }}>
            ¿Tenés un proyecto<br />
            <span style={{ color: '#ff4500' }}>en mente?</span>
          </h2>
          <p style={{ color: 'rgba(242,242,242,0.45)', maxWidth: '500px', margin: '0 auto', lineHeight: 1.8 }}>
            Respondé en menos de 24 horas. Contame tu idea y armamos el plan juntos.
          </p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '2.5rem', alignItems: 'start' }}>

          {/* Left — contact links */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h3 style={{ color: '#f2f2f2', fontWeight: 700, fontSize: '1.1rem', marginBottom: '1.5rem' }}>
              Formas de contacto
            </h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2.5rem' }}>
              {CONTACT_LINKS.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link-card"
                  style={{
                    display: 'flex', alignItems: 'center', gap: '1rem',
                    padding: '1rem 1.25rem',
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.07)',
                    borderRadius: '12px', textDecoration: 'none',
                    transition: 'all 0.2s',
                  }}
                >
                  <div style={{
                    width: '40px', height: '40px', borderRadius: '10px',
                    background: `${link.color}15`,
                    border: `1px solid ${link.color}30`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: link.color, flexShrink: 0,
                  }}>
                    {link.icon}
                  </div>
                  <div>
                    <div style={{ color: 'rgba(242,242,242,0.4)', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '0.2rem' }}>{link.label}</div>
                    <div style={{ color: '#f2f2f2', fontSize: '0.85rem', fontWeight: 500 }}>{link.value}</div>
                  </div>
                  <div style={{ marginLeft: 'auto', color: 'rgba(242,242,242,0.2)', fontSize: '0.8rem' }}>→</div>
                </a>
              ))}
            </div>

            {/* Availability badge */}
            <div style={{
              background: 'rgba(68,255,136,0.06)', border: '1px solid rgba(68,255,136,0.2)',
              borderRadius: '12px', padding: '1.25rem',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#44ff88', display: 'inline-block', boxShadow: '0 0 8px #44ff88' }} />
                <span style={{ color: '#44ff88', fontWeight: 700, fontSize: '0.85rem' }}>Disponible para proyectos</span>
              </div>
              <p style={{ color: 'rgba(242,242,242,0.45)', fontSize: '0.8rem', lineHeight: 1.6 }}>
                Acepto nuevos proyectos freelance. Tiempo de respuesta estimado: menos de 24 hs.
              </p>
            </div>
          </motion.div>

          {/* Right — form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            style={{
              background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: '20px', padding: '2rem',
            }}
          >
            <AnimatePresence mode="wait">
              {submitted ? (
                <motion.div
                  key="success"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  style={{ textAlign: 'center', padding: '3rem 1rem' }}
                >
                  <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                  <h3 style={{ color: '#44ff88', fontWeight: 800, fontSize: '1.3rem', marginBottom: '0.75rem' }}>
                    ¡Mensaje enviado!
                  </h3>
                  <p style={{ color: 'rgba(242,242,242,0.5)', lineHeight: 1.7, marginBottom: '1.5rem' }}>
                    Te respondo en menos de 24 horas. Mientras tanto, podés explorar mis proyectos.
                  </p>
                  <button
                    onClick={() => setSubmitted(false)}
                    style={{
                      padding: '0.6rem 1.5rem', borderRadius: '8px',
                      background: 'rgba(255,69,0,0.1)', border: '1px solid rgba(255,69,0,0.3)',
                      color: '#ff7b47', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600,
                    }}
                  >
                    Enviar otro mensaje
                  </button>
                </motion.div>
              ) : (
                <motion.form key="form" onSubmit={handleSubmit}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 1rem' }}>
                    <InputField label="Nombre *" error={errors.name}>
                      <input
                        className="contact-input"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Tu nombre"
                        style={{ ...inputStyle }}
                      />
                    </InputField>
                    <InputField label="Email *" error={errors.email}>
                      <input
                        className="contact-input"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="tu@email.com"
                        style={{ ...inputStyle }}
                      />
                    </InputField>
                  </div>

                  <InputField label="Teléfono *" error={errors.phoneNumber}>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <select
                        name="phoneCode"
                        value={formData.phoneCode}
                        onChange={handleChange}
                        className="contact-input"
                        style={{ ...inputStyle, width: '130px', flexShrink: 0 }}
                      >
                        {PHONE_CODES.map((p) => (
                          <option key={p.code} value={p.code} style={{ background: '#1a1a1a', color: '#f2f2f2' }}>
                            {p.label}
                          </option>
                        ))}
                      </select>
                      <input
                        className="contact-input"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        placeholder="Número de teléfono"
                        style={{ ...inputStyle }}
                      />
                    </div>
                  </InputField>

                  <InputField label="Mensaje *" error={errors.message}>
                    <textarea
                      className="contact-input"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Contame tu proyecto, idea o consulta..."
                      rows={5}
                      style={{ ...inputStyle, resize: 'vertical', minHeight: '120px', fontFamily: 'inherit' }}
                    />
                  </InputField>

                  {/* Google Calendar toggle */}
                  <div
                    onClick={() => setFormData((p) => ({ ...p, agendarEnGoogle: !p.agendarEnGoogle }))}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '0.75rem',
                      padding: '0.85rem 1rem', borderRadius: '10px',
                      background: formData.agendarEnGoogle ? 'rgba(255,69,0,0.08)' : 'rgba(255,255,255,0.03)',
                      border: `1px solid ${formData.agendarEnGoogle ? 'rgba(255,69,0,0.3)' : 'rgba(255,255,255,0.07)'}`,
                      cursor: 'pointer', marginBottom: '1rem', transition: 'all 0.2s',
                      userSelect: 'none',
                    }}
                  >
                    <div style={{
                      width: '18px', height: '18px', borderRadius: '5px',
                      background: formData.agendarEnGoogle ? '#ff4500' : 'transparent',
                      border: `2px solid ${formData.agendarEnGoogle ? '#ff4500' : 'rgba(255,255,255,0.2)'}`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      transition: 'all 0.2s', flexShrink: 0,
                    }}>
                      {formData.agendarEnGoogle && <span style={{ color: 'white', fontSize: '10px', fontWeight: 900 }}>✓</span>}
                    </div>
                    <div>
                      <div style={{ color: '#f2f2f2', fontSize: '0.85rem', fontWeight: 500 }}>📅 Agendar llamada en Google Calendar</div>
                      <div style={{ color: 'rgba(242,242,242,0.35)', fontSize: '0.75rem' }}>Seleccioná fecha y hora para una reunión virtual</div>
                    </div>
                  </div>

                  <AnimatePresence>
                    {formData.agendarEnGoogle && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        style={{ overflow: 'hidden' }}
                      >
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 1rem' }}>
                          <InputField label="Fecha" error={errors.fecha}>
                            <input
                              className="contact-input"
                              name="fecha"
                              type="date"
                              value={formData.fecha}
                              onChange={handleChange}
                              style={{ ...inputStyle, colorScheme: 'dark' }}
                            />
                          </InputField>
                          <InputField label="Hora" error={errors.hora}>
                            <select
                              className="contact-input"
                              name="hora"
                              value={formData.hora}
                              onChange={handleChange}
                              style={{ ...inputStyle }}
                            >
                              <option value="" style={{ background: '#1a1a1a' }}>Seleccioná</option>
                              {HOURS.map((h) => (
                                <option key={h} value={h} style={{ background: '#1a1a1a', color: '#f2f2f2' }}>{h}</option>
                              ))}
                            </select>
                          </InputField>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  {errors.general && (
                    <p style={{ color: '#fc8181', fontSize: '0.82rem', marginBottom: '1rem', textAlign: 'center' }}>{errors.general}</p>
                  )}

                  <button
                    type="submit"
                    disabled={loading}
                    className="send-btn"
                    style={{
                      width: '100%', padding: '0.9rem',
                      background: loading ? 'rgba(255,69,0,0.4)' : 'linear-gradient(135deg, #ff4500, #ff7b47)',
                      color: 'white', border: 'none', borderRadius: '10px',
                      fontWeight: 700, fontSize: '0.95rem', cursor: loading ? 'not-allowed' : 'pointer',
                      boxShadow: '0 0 20px rgba(255,69,0,0.3)',
                      transition: 'all 0.2s', letterSpacing: '0.5px',
                    }}
                  >
                    {loading ? '⏳ Enviando...' : 'Enviar mensaje →'}
                  </button>
                </motion.form>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
